import type { Context } from '@/overmind';

// TODO: this reaction should be removed and derived state should be used instead. This is a temporary solution to not break the existing functionality.

export function onEvaluation(context: Context) {
  context.reaction(
    state => [state.calculation.gridElementsDetailsByCalculationType] as const,
    async ([details]) => {
      if (details.type !== 'EVALUATED') return;
      context.actions.calculation.createGridElementPropertyAttentionStatuses(
        details.attentionStatuses
      );
    }
  );
}
